import { showSplashscreen } from 'src/services'
import { AccountContext } from 'src/contexts'
import { useHandler } from 'labguard-cdk'

/**
 *  Hook providing the logout handler
 */
export default function useLogout() {
  const { logout } = AccountContext.use()
  return useHandler(() =>
    Promise.resolve()
      .then(showSplashscreen)
      .then(logout)
      .then(() => document.location.replace('/login'))
  )
}
